export const templateChallengeEntriesPublic = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Pasta with 3 ingredients only — Entries — Nemonto</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet">
<style>
  :root{
    --spice:#D85A30; --spice-deep:#B23D18; --cream:#FAECE7; --peach:#F5C4B3;
    --charcoal:#2C2C2A; --herb:#1D9E75; --gold:#FAC775; --muted:#8A7A72;
    --serif:'DM Serif Display', Georgia, serif; --sans:'DM Sans', system-ui, sans-serif;
  }
  *{margin:0;padding:0;box-sizing:border-box;}
  body{background:#F1E4DE; color:var(--charcoal); font-family:var(--sans); font-size:14px; height:100vh; overflow:hidden;}
  a{color:inherit; text-decoration:none;}
  button{font-family:inherit; cursor:pointer; border:none; background:none;}
  :focus-visible{outline:2.5px solid var(--spice); outline-offset:2px; border-radius:4px;}
  ::-webkit-scrollbar{width:7px;}
  ::-webkit-scrollbar-thumb{background:rgba(44,44,42,0.14); border-radius:10px;}
  ::-webkit-scrollbar-track{background:transparent;}

  .app{display:grid; grid-template-columns:264px minmax(0,1fr) 300px; height:100vh; width:100%; max-width:none; margin:0;}

  /* ============ LEFT SIDEBAR ============ */
  .sidebar{padding:26px 18px; display:flex; flex-direction:column; height:100vh; border-right:1px solid rgba(44,44,42,0.07);}
  .brand{display:flex; align-items:center; gap:9px; font-family:var(--serif); font-size:21px; padding:0 10px 28px;}
  .nav-item{display:flex; align-items:center; gap:13px; padding:11px 12px; border-radius:14px; width:100%; font-size:15px; font-weight:500; color:#6B5F58; transition:background .15s, color .15s;}
  .nav-item:hover{background:rgba(44,44,42,0.04);}
  .nav-item.active{background:var(--spice); color:var(--cream);}
  .nav-icon{width:21px; height:21px; flex-shrink:0; display:flex; align-items:center; justify-content:center;}
  .nav-badge{margin-left:auto; background:var(--gold); color:#5A3A00; font-size:10.5px; font-weight:700; padding:2px 7px; border-radius:20px;}
  .nav-item.active .nav-badge{background:rgba(250,236,231,0.25); color:var(--cream);}
  .post-btn{margin:18px 10px 22px; background:var(--spice); color:var(--cream); padding:13px; border-radius:16px; font-size:14.5px; font-weight:700; display:flex; align-items:center; justify-content:center; gap:8px; transition:transform .15s, box-shadow .15s;}
  .post-btn:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}
  .sidebar-spacer{flex:1;}
  .profile-mini{display:flex; align-items:center; gap:10px; padding:9px 10px; border-radius:14px;}
  .pm-avatar{width:38px; height:38px; border-radius:50%; background:#9FE1CB; flex-shrink:0;}
  .pm-name{font-size:13.5px; font-weight:600;}
  .pm-handle{font-size:11.5px; color:#9A8C84;}
  .pm-more{margin-left:auto; color:#9A8C84;}

  /* ============ CENTER — ENTRIES ============ */
  .entries-col{height:100vh; overflow-y:auto; border-right:1px solid rgba(44,44,42,0.07);}

  .entries-header{
    position:sticky; top:0; z-index:5; background:rgba(241,228,222,0.94); backdrop-filter:blur(8px);
    padding:18px 28px 0; border-bottom:1px solid rgba(44,44,42,0.06);
  }
  .back-row{display:flex; align-items:center; gap:10px; font-size:13px; color:#9A8C84; font-weight:600; margin-bottom:14px;}

  .eh-top{display:flex; align-items:flex-start; justify-content:space-between; margin-bottom:14px; gap:14px;}
  .eh-title{font-family:var(--serif); font-size:21px; line-height:1.25; margin-bottom:4px;}
  .eh-host-row{display:flex; align-items:center; gap:7px; margin-bottom:4px;}
  .eh-host-avatar{width:22px; height:22px; border-radius:50%; flex-shrink:0;}
  .eh-meta{font-size:12.5px; color:#9A8C84;}

  .enter-cta-btn{
    background:var(--spice); color:#fff; font-size:13px; font-weight:700; padding:11px 22px; border-radius:30px;
    display:flex; align-items:center; gap:7px; flex-shrink:0; transition:transform .15s, box-shadow .15s;
  }
  .enter-cta-btn:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}
  .enter-cta-btn.disabled{background:rgba(44,44,42,0.08); color:#9A8C84; cursor:default;}
  .enter-cta-btn.disabled:hover{transform:none; box-shadow:none;}

  .status-banner{
    border-radius:14px; padding:12px 16px; font-size:12.5px; margin-bottom:14px; display:flex; align-items:center; gap:9px; line-height:1.5;
  }
  .status-banner.pending{background:var(--charcoal); color:rgba(250,236,231,0.85);}
  .status-banner.pending b{color:var(--gold);}
  .status-banner.decided{background:rgba(250,199,117,0.16); color:#8A5A00;}
  .status-banner.decided b{color:#5A3A00;}

  .filter-row{display:flex; gap:7px; padding-bottom:14px; flex-wrap:wrap;}
  .filter-pill{font-size:12px; font-weight:600; padding:7px 13px; border-radius:20px; background:#fff; border:1px solid rgba(44,44,42,0.1); color:#6B5F58;}
  .filter-pill.active{background:var(--spice); color:#fff; border-color:var(--spice);}

  .entries-body{padding:18px 28px 60px; max-width:none;}

  .entry-card{background:#fff; border-radius:20px; padding:16px; margin-bottom:16px; border:1px solid rgba(44,44,42,0.06);}
  .entry-card.is-winner{border:2px solid var(--gold); background:rgba(250,199,117,0.05);}

  .winner-flag{
    display:flex; align-items:center; gap:7px; background:rgba(250,199,117,0.2); color:#8A5A00; font-size:11.5px;
    font-weight:700; padding:7px 13px; border-radius:20px; margin-bottom:12px;
  }

  .ec-top{display:flex; align-items:center; gap:10px; margin-bottom:11px;}
  .ec-avatar{width:38px; height:38px; border-radius:50%; flex-shrink:0;}
  .ec-name{font-size:13.5px; font-weight:600; display:flex; align-items:center; gap:5px;}
  .ec-time{font-size:11.5px; color:#9A8C84;}
  .ec-reaction{margin-left:auto; font-size:10.5px; font-weight:700; padding:4px 10px; border-radius:20px;}
  .ec-reaction.nailed{background:#E1F5EE; color:#085041;}
  .ec-reaction.twist{background:#FAEEDA; color:#633806;}
  .ec-reaction.almost{background:#F1E4DE; color:#6B5F58;}

  .ec-media{height:160px; border-radius:14px; margin-bottom:11px; display:flex; align-items:center; justify-content:center; position:relative;}
  .ec-play{position:absolute; bottom:10px; right:10px; width:34px; height:34px; border-radius:50%; background:rgba(255,255,255,0.92); display:flex; align-items:center; justify-content:center; color:var(--spice-deep);}

  .ec-text{font-size:13.5px; color:#3A3330; line-height:1.55; margin-bottom:12px;}
  .ec-cook-time{display:inline-flex; align-items:center; gap:5px; font-size:11.5px; color:#9A8C84; background:#F8EFEB; padding:4px 10px; border-radius:20px; margin-bottom:12px;}

  .ec-actions{display:flex; align-items:center; gap:18px; padding-top:11px; border-top:1px solid rgba(44,44,42,0.06);}
  .ec-action{display:flex; align-items:center; gap:6px; font-size:12.5px; color:#6B5F58; font-weight:500;}
  .ec-action.liked{color:var(--spice-deep);}
  .ec-action.cheer{cursor:pointer; transition:transform .12s;}
  .ec-action.cheer:active{transform:scale(0.9);}
  .ec-share{margin-left:auto;}

  /* ============ RIGHT RAIL ============ */
  .right-rail{height:100vh; overflow-y:auto; padding:24px 20px 40px;}
  .rail-block{margin-bottom:26px;}
  .rail-head{margin-bottom:14px;}
  .rail-head h3{font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:#6B5F58;}

  .challenge-mini{background:var(--charcoal); border-radius:18px; padding:18px; position:relative; overflow:hidden;}
  .challenge-mini::before{content:''; position:absolute; top:-50px; right:-40px; width:120px; height:120px; background:radial-gradient(circle, rgba(216,90,48,0.4), transparent 70%);}
  .cm-live{display:inline-flex; align-items:center; gap:5px; background:var(--spice); color:#fff; font-size:10px; font-weight:700; padding:4px 9px; border-radius:20px; margin-bottom:10px; position:relative;}
  .cm-live .dot{width:5px; height:5px; border-radius:50%; background:#fff; animation:pulse 1.8s infinite;}
  @keyframes pulse{0%,100%{opacity:1;}50%{opacity:0.3;}}
  .cm-title{font-family:var(--serif); font-size:15px; color:var(--cream); margin-bottom:12px; line-height:1.3; position:relative;}
  .cm-stats{display:flex; gap:8px; position:relative;}
  .cm-stat{flex:1; background:rgba(250,236,231,0.07); border-radius:10px; padding:9px; text-align:center;}
  .cm-stat b{display:block; font-size:15px; color:var(--gold); font-family:var(--serif);}
  .cm-stat span{font-size:9.5px; color:rgba(250,236,231,0.55);}
  .ingredient-recap{display:flex; gap:6px; flex-wrap:wrap; margin-top:14px; position:relative;}
  .ingredient-recap span{background:rgba(250,236,231,0.1); color:var(--cream); font-size:10.5px; padding:4px 9px; border-radius:20px;}

  .host-card{background:#fff; border-radius:16px; padding:16px; border:1px solid rgba(44,44,42,0.06); text-align:center;}
  .hc-avatar{width:54px; height:54px; border-radius:50%; margin:0 auto 10px; position:relative;}
  .hc-ring{position:absolute; inset:-3px; border-radius:50%; border:2px solid var(--gold);}
  .hc-name{font-size:14px; font-weight:600; margin-bottom:2px;}
  .hc-handle{font-size:11.5px; color:#9A8C84; margin-bottom:12px;}
  .hc-follow{width:100%; background:var(--spice); color:#fff; font-size:12.5px; font-weight:700; padding:9px 0; border-radius:14px;}
  .hc-follow.following{background:#fff; border:1.5px solid rgba(44,44,42,0.14); color:var(--charcoal);}

  .similar-card{display:flex; gap:11px; align-items:center; padding:9px 0; border-bottom:1px solid rgba(44,44,42,0.06); cursor:pointer;}
  .similar-card:last-child{border-bottom:none;}
  .sim-thumb{width:48px; height:48px; border-radius:11px; flex-shrink:0; display:flex; align-items:center; justify-content:center;}
  .sim-info b{font-size:12px; font-weight:600; display:block; margin-bottom:2px; line-height:1.3;}
  .sim-info span{font-size:10.5px; color:#9A8C84;}

  @media (max-width:1180px){
    .app{grid-template-columns:84px minmax(0,1fr) 300px;}
    .brand span.brand-text, .nav-item span.nav-label, .post-btn span.btn-label, .pm-name, .pm-handle{display:none;}
    .nav-item{justify-content:center;} .nav-badge{display:none;} .post-btn{padding:13px;} .profile-mini{justify-content:center;}
  }
  @media (max-width:900px){
    .app{grid-template-columns:84px minmax(0,1fr);}
    .right-rail{display:none;}
  }
</style>
</head>
<body>

<div class="app">

  <!-- ================= LEFT SIDEBAR ================= -->
  <aside class="sidebar">
    <div class="brand">
      <img src="../image/nemonto-logo.png" alt="Nemonto" style="height:32px; width:auto; display:block;" />
    </div>
    <nav>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 11l8-7 8 7M6 10v9a1 1 0 001 1h4v-6h2v6h4a1 1 0 001-1v-9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Home</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/><path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Explore</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 4h16v12H7l-3 3V4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Made it</span>
      </a>
      <a class="nav-item active" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 21V5a1 1 0 011-1h14a1 1 0 011 1v16l-8-4-8 4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Challenges</span>
        <span class="nav-badge">3 live</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M20.8 4.6c-1.5-1.5-4-1.5-5.6.1L12 7.9 8.8 4.7c-1.6-1.6-4.1-1.6-5.6-.1-1.5 1.5-1.5 4 .1 5.6L12 19l8.7-8.8c1.6-1.6 1.6-4.1.1-5.6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Saved</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M21 11.5a8.4 8.4 0 01-1.2 4.4L21 20l-4.3-1.2a8.5 8.5 0 11-1.8-15.6 8.5 8.5 0 016.1 7.3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Messages</span>
        <span class="nav-badge">2</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="8" r="3.4" stroke="currentColor" stroke-width="1.6"/><path d="M3 19c0-3 2.5-5 6-5s6 2 6 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Profile</span>
      </a>
    </nav>
    <div class="post-btn">
      <svg width="17" height="17" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      <span class="btn-label">New recipe</span>
    </div>
    <div class="sidebar-spacer"></div>
    <div class="profile-mini">
      <div class="pm-avatar"></div>
      <div><div class="pm-name">Priya Rajan</div><div class="pm-handle">@priyacooks</div></div>
      <span class="pm-more">⋯</span>
    </div>
  </aside>

  <!-- ================= CENTER — ENTRIES (PUBLIC VIEW) ================= -->
  <main class="entries-col">

    <div class="entries-header">
      <div class="back-row">
        <svg width="16" height="16" viewBox="0 0 16 16"><path d="M10 13L5 8l5-5" stroke="#9A8C84" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
        Back to challenges
      </div>

      <div class="eh-top">
        <div>
          <p class="eh-title">Pasta with 3 ingredients only</p>
          <div class="eh-host-row">
            <div class="eh-host-avatar" style="background:#F0997B;"></div>
            <span class="eh-meta">Hosted by <b style="color:#6B5F58;">Maria K.</b> 🏅 · 84 entries · 47h 22m remaining</span>
          </div>
        </div>
        <a href="#" class="enter-cta-btn">🍳 Enter this challenge</a>
      </div>

      <div class="status-banner pending">
        <span>⏳</span>
        <span>Entries are still open. <b>Maria K.</b> will personally review every submission and crown a winner once the challenge closes.</span>
      </div>

      <div class="filter-row">
        <span class="filter-pill active" data-filter="all">All entries · 84</span>
        <span class="filter-pill" data-filter="nailed">🔥 Nailed it · 51</span>
        <span class="filter-pill" data-filter="twist">🔄 My twist · 19</span>
        <span class="filter-pill" data-filter="almost">😅 Almost · 14</span>
      </div>
    </div>

    <div class="entries-body" id="entriesBody">

      <!-- ENTRY 1 -->
      <div class="entry-card" data-reaction="nailed">
        <div class="ec-top">
          <div class="ec-avatar" style="background:#9FE1CB;"></div>
          <div><div class="ec-name">Priya R. 🏅</div><div class="ec-time">2 hours ago</div></div>
          <span class="ec-reaction nailed">🔥 Nailed it</span>
        </div>
        <div class="ec-media" style="background:linear-gradient(150deg,#6FCBA4,#0D6B4E);">
          <svg width="38" height="38" viewBox="0 0 100 100"><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.9"/><circle cx="58" cy="40" r="8" fill="#fff" opacity="0.7"/></svg>
          <div class="ec-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
        </div>
        <span class="ec-cook-time">⏱ 12 min</span>
        <p class="ec-text">Used the pasta water trick exactly like you said — went from grainy to silky the second time around.</p>
        <div class="ec-actions">
          <span class="ec-action cheer liked" data-count="241">♥ 241</span>
          <span class="ec-action">💬 18</span>
          <span class="ec-action ec-share">↗ Share</span>
        </div>
      </div>

      <!-- ENTRY 2 -->
      <div class="entry-card" data-reaction="twist">
        <div class="ec-top">
          <div class="ec-avatar" style="background:#AFA9EC;"></div>
          <div><div class="ec-name">James L.</div><div class="ec-time">4 hours ago</div></div>
          <span class="ec-reaction twist">🔄 My twist</span>
        </div>
        <div class="ec-media" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
          <svg width="38" height="38" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.6"/></svg>
          <div class="ec-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
        </div>
        <span class="ec-cook-time">⏱ 18 min</span>
        <p class="ec-text">Added a little lemon zest at the end — cuts through the richness nicely. Still very much your recipe though.</p>
        <div class="ec-actions">
          <span class="ec-action cheer" data-count="87">♡ 87</span>
          <span class="ec-action">💬 9</span>
          <span class="ec-action ec-share">↗ Share</span>
        </div>
      </div>

      <!-- ENTRY 3 -->
      <div class="entry-card" data-reaction="nailed">
        <div class="ec-top">
          <div class="ec-avatar" style="background:#F5C4B3;"></div>
          <div><div class="ec-name">Chen W.</div><div class="ec-time">6 hours ago</div></div>
          <span class="ec-reaction nailed">🔥 Nailed it</span>
        </div>
        <div class="ec-media" style="background:linear-gradient(150deg,#E8693D,#993C1D);">
          <svg width="38" height="38" viewBox="0 0 100 100"><circle cx="50" cy="50" r="22" fill="#fff" opacity="0.6"/></svg>
          <div class="ec-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
        </div>
        <span class="ec-cook-time">⏱ 15 min</span>
        <p class="ec-text">Didn't expect 3 ingredients to taste this good. My kitchen smells like a trattoria right now.</p>
        <div class="ec-actions">
          <span class="ec-action cheer" data-count="64">♡ 64</span>
          <span class="ec-action">💬 5</span>
          <span class="ec-action ec-share">↗ Share</span>
        </div>
      </div>

      <!-- ENTRY 4 -->
      <div class="entry-card" data-reaction="almost">
        <div class="ec-top">
          <div class="ec-avatar" style="background:#FAC775;"></div>
          <div><div class="ec-name">Sofia M. 🏅</div><div class="ec-time">Yesterday</div></div>
          <span class="ec-reaction almost">😅 Almost</span>
        </div>
        <p class="ec-text">First attempt clumped on me but I think I added the cheese too fast. Trying again tomorrow with the slow whisk tip.</p>
        <div class="ec-actions">
          <span class="ec-action cheer" data-count="19">♡ 19</span>
          <span class="ec-action">💬 3</span>
          <span class="ec-action ec-share">↗ Share</span>
        </div>
      </div>

    </div>
  </main>

  <!-- ================= RIGHT RAIL ================= -->
  <aside class="right-rail">

    <div class="rail-block">
      <div class="challenge-mini">
        <span class="cm-live"><span class="dot"></span>LIVE NOW</span>
        <p class="cm-title">Pasta with 3 ingredients only</p>
        <div class="cm-stats">
          <div class="cm-stat"><b>84</b><span>entries</span></div>
          <div class="cm-stat"><b>30m</b><span>max cook</span></div>
          <div class="cm-stat"><b>47h</b><span>remaining</span></div>
        </div>
        <div class="ingredient-recap">
          <span>🍝 Pasta</span><span>🥚 Eggs</span><span>🧀 Pecorino</span>
        </div>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Hosted by</h3></div>
      <div class="host-card">
        <div class="hc-avatar" style="background:#F0997B;"><div class="hc-ring"></div></div>
        <p class="hc-name">Maria K.</p>
        <p class="hc-handle">@mariakcooks · 8.2k followers</p>
        <button class="hc-follow" id="hostFollowBtn">Follow Maria</button>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Other live challenges</h3></div>
      <div class="similar-card">
        <div class="sim-thumb" style="background:linear-gradient(150deg,#6FCBA4,#0D6B4E);">
          <svg width="22" height="22" viewBox="0 0 100 100"><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.85"/></svg>
        </div>
        <div class="sim-info"><b>One-pan South Asian breakfast</b><span>by Priya R. · 31 entries</span></div>
      </div>
      <div class="similar-card">
        <div class="sim-thumb" style="background:linear-gradient(150deg,#FCD58E,#BA7517);">
          <svg width="22" height="22" viewBox="0 0 100 100"><path d="M24 48 Q24 70 50 70 Q76 70 76 48 Z" fill="#fff" opacity="0.85"/></svg>
        </div>
        <div class="sim-info"><b>No-knead focaccia, your way</b><span>by Sofia M. · 52 entries</span></div>
      </div>
      <div class="similar-card">
        <div class="sim-thumb" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
          <svg width="22" height="22" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.6"/></svg>
        </div>
        <div class="sim-info"><b>Weeknight curry, 20 min flat</b><span>by James L. · 26 entries</span></div>
      </div>
    </div>

  </aside>

</div>

<script>
  document.querySelectorAll('.filter-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      document.querySelectorAll('.filter-pill').forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      const filter = pill.dataset.filter;
      document.querySelectorAll('.entry-card').forEach(card => {
        card.style.display = (filter === 'all' || card.dataset.reaction === filter) ? 'block' : 'none';
      });
    });
  });

  document.querySelectorAll('.ec-action.cheer').forEach(btn => {
    btn.addEventListener('click', () => {
      const liked = btn.classList.toggle('liked');
      let count = parseInt(btn.dataset.count);
      count = liked ? count + 1 : count - 1;
      btn.dataset.count = count;
      btn.textContent = (liked ? '♥ ' : '♡ ') + count;
    });
  });

  const hostFollowBtn = document.getElementById('hostFollowBtn');
  hostFollowBtn.addEventListener('click', () => {
    const following = hostFollowBtn.classList.toggle('following');
    hostFollowBtn.textContent = following ? 'Following' : 'Follow Maria';
  });
</script>

</body>
</html>

`;
